import React from 'react'

import {ChevronLeftIcon, ChevronRightIcon} from '../../icons'
import {Box, Button, Flex, Text} from '../../../vanilla'
import {usePagination} from 'react-instantsearch-hooks-web'

export const Pagination = () => {
  const {currentRefinement, nbPages, refine, canRefine, isFirstPage, isLastPage} = usePagination()

  const moveToTop = () => {
    const anchor = document.querySelector('#stats-text')
    const coordinates = {top: 0, left: 0}
    if (anchor) {
      coordinates.top = anchor.getBoundingClientRect?.()?.top + window.scrollY
    }

    window.scrollTo({...coordinates, behavior: 'auto'})
  }

  const onPrevious = () => {
    if (canRefine && !isFirstPage) {
      refine(currentRefinement - 1)
      moveToTop()
    }
  }

  const onNext = () => {
    if (canRefine && !isLastPage) {
      refine(currentRefinement + 1)
      moveToTop()
    }
  }
  return (
    <Flex justify="center">
      <Flex align="center" background="white" border="1px" borderColor="gray200">
        <Button
          aria-label="Previous Page"
          variant="unstyled"
          onClick={onPrevious}
          background={{hover: 'gray50', default: 'gray25'}}
          style={{borderRadius: 0, borderColor: '#e5e4e5'}}
          height="40px"
        >
          <ChevronLeftIcon color="gray800" boxSize="16px" />
        </Button>
        <Box
          borderRight="1px"
          borderLeft="1px"
          style={{borderRadius: 0, borderColor: '#e5e4e5'}}
          paddingX="20px"
          paddingY="8px"
        >
          <Text>
            Page {currentRefinement + 1} of {nbPages}
          </Text>
        </Box>
        <Button
          aria-label="Next Page"
          variant="unstyled"
          onClick={onNext}
          background={{hover: 'gray50', default: 'gray25'}}
          style={{borderRadius: 0, borderColor: '#e5e4e5'}}
          borderRadius="none"
          height="40px"
        >
          <ChevronRightIcon color="gray800" boxSize="16px" />
        </Button>
      </Flex>
    </Flex>
  )
}
